import PropTypes from 'prop-types';
import React from 'react';
import './LoadingSpinner.css';

const LoadingSpinner = ({ opacity, blockUI, blockDrawer }) => {
  let currStyle = {
    top: '80px',
    left: '93px',
    width: '14px',
    height: '40px',
    background: '#006aff',
    transform: 'rotate(0deg) translate(0, -60px)',
    borderRadius: '10px',
    position: 'absolute'
  };

  return (
    <div
      className={`${blockUI ? 'spinner-loading-blockUI' : ''} ${blockDrawer ? ' spinner-loading-block-drawer-ui' : ''}`}
    >
      <div className={`spinner-loading-block ${blockDrawer ? ' spinner-loading-block-drawer' : ''}`}>
        <div className="common__uil-spinnerdefault-css">
          <div style={currStyle}></div>
          <div style={Object.assign({}, currStyle, { transform: 'rotate(30deg) translate(0, -60px)' })}></div>
          <div style={Object.assign({}, currStyle, { transform: 'rotate(60deg) translate(0, -60px)' })}></div>
          <div style={Object.assign({}, currStyle, { transform: 'rotate(90deg) translate(0, -60px)' })}></div>
          <div style={Object.assign({}, currStyle, { transform: 'rotate(120deg) translate(0, -60px)' })}></div>
          <div style={Object.assign({}, currStyle, { transform: 'rotate(150deg) translate(0, -60px)' })}></div>
          <div style={Object.assign({}, currStyle, { transform: 'rotate(180deg) translate(0, -60px)' })}></div>
          <div style={Object.assign({}, currStyle, { transform: 'rotate(210deg) translate(0, -60px)' })}></div>
          <div style={Object.assign({}, currStyle, { transform: 'rotate(240deg) translate(0, -60px)' })}></div>
          <div style={Object.assign({}, currStyle, { transform: 'rotate(270deg) translate(0, -60px)' })}></div>
          <div style={Object.assign({}, currStyle, { transform: 'rotate(300deg) translate(0, -60px)' })}></div>
          <div style={Object.assign({}, currStyle, { transform: 'rotate(330deg) translate(0, -60px)' })}></div>
        </div>
      </div>
    </div>
  );
};
LoadingSpinner.propTypes = {
  opacity: PropTypes.number,
  blockUI: PropTypes.bool,
  blockDrawer: PropTypes.bool
};
LoadingSpinner.defaultProps = {
  opacity: 0.7,
  blockUI: false
};
export default LoadingSpinner;
